//modal
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

//user
export const LOGGING_IN = 'LOGGING_IN';
export const GOT_USER = 'GOT_USER';
export const SET_ACCOUNT_TYPE = 'SET_ACCOUNT_TYPE';
export const SET_ACCOUNT_DATA = 'SET_ACCOUNT_DATA';
export const SET_ORG_DISPLAY_NAME = 'SET_ORG_DISPLAY_NAME';
export const UPDATE_GIVING_OPTIONS = 'UPDATE_GIVING_OPTIONS';
export const GET_IAV_TOKEN = 'GET_IAV_TOKEN';
export const SET_USER_EXISTS = 'SET_USER_EXISTS';

//transactions
export const LOAD_TRANSACTIONS = 'LOAD_TRANSACTIONS';
export const SET_BALANCE = 'SET_BALANCE';

//deposits
export const LOAD_DEPOSITS = 'LOAD_DEPOSITS';
export const LOAD_FUNDS_AVAILABLE = 'LOAD_FUNDS_AVAILABLE';

//loader
export const APP_IS_LOADING = 'APP_IS_LOADING';

//dashboard
export const SET_SELECTED_GIVING_ORGANIZATION =
  'SET_SELECTED_GIVING_ORGANIZATION';
export const SET_DASHBOARD_PAGE = 'SET_DASHBOARD_PAGE';
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const SET_LAST_GIFT_AMOUNT = 'SET_LAST_GIFT_AMOUNT';
export const SET_PROCESSOR_TYPES = 'SET_PROCESSOR_TYPES';

//subscriptions
export const LOAD_SUBSCRIPTIONS = 'LOAD_SUBSCRIPTIONS';

//users
export const LOAD_USERS = 'LOAD_USERS';

//billing
export const LOAD_BILLING_DETAILS = 'LOAD_BILLING_DETAILS';
export const LOAD_BILLING_HISTORY = 'LOAD_BILLING_HISTORY';

//paymentMethod
export const SET_BANK_ACCOUNT = 'SET_BANK_ACCOUNT';
export const SET_ACH_TOKEN = 'SET_ACH_TOKEN';
export const SET_DONATION_FEE = 'SET_DONATION_FEE';